export default {
  "months": {
    "long": [
      "janvier", "février", "mars", "avril", "mai", "juin",
      "juillet", "août", "septembre", "octobre", "novembre", "décembre"
    ],
    "short": [
      "janv.", "févr.", "mars", "avr.", "mai", "juin",
      "juil.", "août", "sept.", "oct.", "nov.", "déc."
    ]
  },
  "weekdays": {
    "long": [
      "lundi", "mardi", "mercredi",
      "jeudi", "vendredi", "samedi", "dimanche"
    ],
    "short": [
      "lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."
    ]
  },
  "buttons": {
    "today": "Aujourd'hui",
    "cancel": "Annuler",
    "select": "Sélectionner"
  }
};
